import React, {Component} from 'react';
import Dropdown from "../../../controls/Dropdown";
import BackEnd from "../../../backend/BackEnd";
import CompanyContactTable from "./components/CompanyContactTable";
import CompanyAddressTable from "./components/CompanyAddressTable";
import CompanyProductTable from "./components/CompanyProductTable";
import PlainDropdown from "../../../controls/PlainDropdown";
import {errorToast, successToast} from "../../../utils/toasts";
import {withRouter} from "react-router";
import {conditional, number, phoneNumberRequired, required, validate} from "../../../utils/validation";
import Fieldset from "../../../utils/components/Fieldset";

class CompanyForm extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        isLoading: false,
        typeId: 1,
        name: '',
        contractor: null,
        contractorId: 0,
        contacts: [],
        isProviderOfUsed: false,
        isProviderOfNew: false,
        hasDryingRoom: false,
        completedSupplyCount: '',
        failedSupplyCount: '',
        repliedSupplyCount: '',
        serviceLevelTypeId: '',
        isAudited: false,
        addresses: [],
        isContractSigned: false,
        inn: '',
        isTermsAccepted: false,
        paymentTypeId: 0,
        hasPaymentDelay: false,
        paymentDelayDays: '',
        hasDelivery: false,
        deliveryPrice: '',
        products: [],
        comment: '',
        addressTypes: [],
        paymentTypes: [],
        serviceLevels: [],
        taxTypes: [],
        formState: {}
    };
    fieldUpdateHandle = (event => this.setState({[event.target.name]: event.target.value}));
    flagUpdateHandle = (event => this.setState({[event.target.name]: event.target.checked}));
    getForm = new BackEnd.CompaniesAdmin.GetCompanyForm(this);
    createCompany = new BackEnd.CompaniesAdmin.CreateCompany(this);
    updateCompany = new BackEnd.CompaniesAdmin.UpdateCompany(this);
    formMetadata = {
        name: [required('Введите название')],
        contractorId: [conditional(() => this.state.typeId == 3, required('Выберите контрагента'))]
    };

    async componentDidMount() {
        const {companyId} = this.props.match.params;
        const {data, catalogs} = await this.getForm.call({companyId});
        const contractor = this.props.location.state || data ? data.contractor : null;

        this.setState({
            serviceLevelTypeId: 4,
            paymentTypeId: catalogs.paymentTypes[0].id,
            ...(data || {}),
            contractor,
            contractorId: (contractor || {}).id,
            ...catalogs
        });
    }

    async componentWillReceiveProps(nextProps) {
        const {companyId} = nextProps.match.params;
        const {data, catalogs} = await this.getForm.call({companyId});
        const contractor = this.props.location.state || data.contractor;

        this.setState({
            serviceLevelTypeId: 4,
            paymentTypeId: catalogs.paymentTypes[0].id,
            ...(data || {}),
            contractor,
            contractorId: (contractor || {}).id,
            ...catalogs
        });
    }

    render() {
        const {companyId} = this.props.match.params;
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>Новая компания</h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="panel">
                            <div className="panel-body">
                                <form className={this.state.isLoading ? 'form-loading' : ''}>
                                    <div className="row">
                                        <div className="col-md-8">
                                            <fieldset className="form-group">
                                                <label htmlFor="email">Тип компании</label>
                                                <div>
                                                    <label className="radio-inline">
                                                        <input type="radio" name="typeId" value="1"
                                                               checked={this.state.typeId == 1}
                                                               onChange={this.fieldUpdateHandle}/>
                                                        {' '}
                                                        Поставщик
                                                    </label>
                                                    <label className="radio-inline">
                                                        <input type="radio" name="typeId" value="3"
                                                               checked={this.state.typeId == 3}
                                                               onChange={this.fieldUpdateHandle}/>
                                                        {' '}
                                                        Клиент
                                                    </label>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Fieldset formState={this.state.formState} fieldName="name">
                                                <label className="control-label required" htmlFor="name">
                                                    Название
                                                </label>
                                                <input type="text" className="form-control" name="name" id="name"
                                                       value={this.state.name}
                                                       onChange={this.fieldUpdateHandle}/>
                                            </Fieldset>
                                        </div>
                                        <div className="col-md-6">
                                            <Fieldset formState={this.state.formState} fieldName="contractorId">
                                                <label className="control-label required" htmlFor="contractorId">
                                                    Контрагент из 1С
                                                </label>
                                                <Dropdown className="form-control"
                                                          name="contractorId" id="contractorId"
                                                          item={this.state.contractor}
                                                          dataSource={new BackEnd.CompaniesAdmin.GetContractorsByTerm()}
                                                          value={this.state.contractorId}
                                                          onChange={this.fieldUpdateHandle}/>
                                            </Fieldset>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h5 className="m-t-2 m-b-1">Контакты</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <CompanyContactTable contacts={this.state.contacts}
                                                                 onChange={contacts => this.updateContacts(contacts)}/>
                                        </div>
                                    </div>
                                    {
                                        this.state.typeId == 1 &&
                                        <div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <h5 className="m-t-2 m-b-1">Информация о поставщике</h5>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <table className="table no-margin">
                                                        <thead>
                                                        <tr>
                                                            <th>Поставщик Б/У поддонов</th>
                                                            <th>Поставщик новых поддонов</th>
                                                            <th>Наличие сушильной камеры</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td>
                                                                <label className="checkbox-inline">
                                                                    <input type="checkbox" name="isProviderOfUsed"
                                                                           checked={this.state.isProviderOfUsed}
                                                                           onChange={this.flagUpdateHandle}/>
                                                                    &nbsp;
                                                                </label>
                                                            </td>
                                                            <td>
                                                                <label className="checkbox-inline">
                                                                    <input type="checkbox" name="isProviderOfNew"
                                                                           checked={this.state.isProviderOfNew}
                                                                           onChange={this.flagUpdateHandle}/>
                                                                    &nbsp;
                                                                </label>
                                                            </td>
                                                            <td>
                                                                <label className="checkbox-inline">
                                                                    <input type="checkbox" name="hasDryingRoom"
                                                                           checked={this.state.hasDryingRoom}
                                                                           onChange={this.flagUpdateHandle}/>
                                                                    &nbsp;
                                                                </label>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <Fieldset formState={this.state.formState} fieldName="completedSupplyCount">
                                                        <label htmlFor="completedSupplyCount">Поставок выполнено</label>
                                                        <input type="number" className="form-control"
                                                               id="completedSupplyCount" name="completedSupplyCount"
                                                               min="0"
                                                               value={this.state.completedSupplyCount || ''}
                                                               onChange={this.fieldUpdateHandle}/>
                                                    </Fieldset>
                                                    <Fieldset formState={this.state.formState} fieldName="failedSupplyCount">
                                                        <label htmlFor="failedSupplyCount">
                                                            Поставок сорвано
                                                        </label>
                                                        <input type="number" className="form-control"
                                                               id="failedSupplyCount" name="failedSupplyCount"
                                                               min="0"
                                                               value={this.state.failedSupplyCount || ''}
                                                               onChange={this.fieldUpdateHandle}/>
                                                    </Fieldset>
                                                    <fieldset className="form-group">
                                                        <label htmlFor="repliedSupplyCount">
                                                            % заявок, по которым были получены отклики
                                                        </label>
                                                        <input type="number" className="form-control"
                                                               id="repliedSupplyCount" name="repliedSupplyCount"
                                                               min="0"
                                                               value={this.state.repliedSupplyCount || ''}
                                                               onChange={this.fieldUpdateHandle}/>
                                                    </fieldset>
                                                </div>
                                                <div className="col-md-6">
                                                    <fieldset className="form-group">
                                                        <label htmlFor="serviceLevelTypeId">Уровень сервиса</label>
                                                        <PlainDropdown className="form-control"
                                                                       id="serviceLevelTypeId" name="serviceLevelTypeId"
                                                                       items={this.state.serviceLevels}
                                                                       value={this.state.serviceLevelTypeId}
                                                                       onChange={this.fieldUpdateHandle}>
                                                        </PlainDropdown>
                                                    </fieldset>
                                                    <fieldset className="form-group">
                                                        <label className="checkbox-inline">
                                                            <input type="checkbox" name="isAudited"
                                                                   checked={this.state.isAudited}
                                                                   onChange={this.flagUpdateHandle}/>
                                                            {' '}
                                                            Аудит проведён
                                                        </label>
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h5 className="m-t-2 m-b-1">Адреса</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <CompanyAddressTable addresses={this.state.addresses}
                                                                 addressTypes={this.state.addressTypes}
                                                                 onChange={addresses => this.updateAddresses(addresses)}/>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h5 className="m-t-2 m-b-1">Коммерческие условия</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <fieldset className="form-group">
                                                <label className="checkbox-inline">
                                                    <input type="checkbox" name="isContractSigned"
                                                           checked={this.state.isContractSigned}
                                                           onChange={this.flagUpdateHandle}/>
                                                    {' '}
                                                    Договор подписан
                                                </label>
                                            </fieldset>
                                            <fieldset className="form-group">
                                                <label htmlFor="inn">ИНН</label>
                                                <input type="text" className="form-control" name="inn" id="inn"
                                                       value={this.state.inn || ''}
                                                       onChange={this.fieldUpdateHandle}/>
                                            </fieldset>
                                            <fieldset className="form-group">
                                                <label className="checkbox-inline">
                                                    <input type="checkbox" name="isTermsAccepted"
                                                           checked={this.state.isTermsAccepted}
                                                           onChange={this.flagUpdateHandle}/>
                                                    {' '}
                                                    Приняты условия работы с NP
                                                </label>
                                            </fieldset>
                                            <fieldset className="form-group">
                                                <label htmlFor="paymentTypeId">Тип оплаты</label>
                                                <PlainDropdown className="form-control"
                                                               name="paymentTypeId" id="paymentTypeId"
                                                               items={this.state.paymentTypes}
                                                               value={this.state.paymentTypeId}
                                                               onChange={this.fieldUpdateHandle}/>
                                            </fieldset>
                                        </div>
                                        <div className="col-md-6">
                                            <fieldset className="form-group">
                                                <label className="checkbox-inline">
                                                    <input type="checkbox" name="hasPaymentDelay"
                                                           checked={this.state.hasPaymentDelay}
                                                           onChange={this.flagUpdateHandle}/> Отсрочка
                                                </label>
                                            </fieldset>
                                            <fieldset className="form-group">
                                                <label htmlFor="paymentDelayDays">Кол-во дней отсрочки</label>
                                                <input type="number" className="form-control"
                                                       id="paymentDelayDays" name="paymentDelayDays"
                                                       placeholder="Кол-во дней отсрочки"
                                                       disabled={!this.state.hasPaymentDelay}
                                                       value={this.state.paymentDelayDays || ''}
                                                       onChange={this.fieldUpdateHandle}/>
                                            </fieldset>
                                            <fieldset className="form-group">
                                                <label className="checkbox-inline">
                                                    <input type="checkbox" name="hasDelivery"
                                                           checked={this.state.hasDelivery}
                                                           onChange={this.flagUpdateHandle}/> Доставка
                                                </label>
                                            </fieldset>
                                            <fieldset className="form-group">
                                                <label htmlFor="deliveryPrice">Стоимость доставки</label>
                                                <input type="number" className="form-control"
                                                       id="deliveryPrice" name="deliveryPrice"
                                                       placeholder="Стоимость доставки"
                                                       disabled={!this.state.hasDelivery}
                                                       value={this.state.deliveryPrice || ''}
                                                       onChange={this.fieldUpdateHandle}/>
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h5 className="m-t-2 m-b-1">Продукция</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <CompanyProductTable products={this.state.products}
                                                                 taxTypes={this.state.taxTypes}
                                                                 onChange={products => this.updateProducts(products)}/>
                                        </div>
                                    </div>
                                    <div className="row m-t-2">
                                        <div className="col-md-6">
                                            <fieldset className="form-group">
                                                <label htmlFor="comment">Комментарий</label>
                                                <textarea className="form-control" name="comment" id="comment"
                                                          rows="3"
                                                          value={this.state.comment}
                                                          onChange={this.fieldUpdateHandle}/>
                                            </fieldset>
                                        </div>
                                    </div>
                                    <button type="button" className="btn btn-lg btn-primary m-t-3"
                                            onClick={() => this.createOrUpdate()}>
                                        {companyId ? 'Отредактировать' : 'Создать'} компанию
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    async createOrUpdate() {
        const {companyId} = this.props.match.params;

        const {isValid, ...formState} = validate(this.state, this.formMetadata);
        if (!isValid) {
            this.setState({formState});
            return;
        }

        if (companyId) {
            let result = await this.updateCompany.call({
                companyId,
                dto: this.createFormDto()
            });

            if (result.success) {
                successToast(`Компания ${this.state.name} успешно отредактирована`);
                this.props.history.push('/catalogs/companies');
            }
            else {
                errorToast('Возникли ошибки при редактировании компании');
            }
        }
        else {
            let result = await this.createCompany.call({
                dto: this.createFormDto()
            });

            if (result.success) {
                successToast(`Компания ${this.state.name} успешно создана`);
                this.props.history.push('/catalogs/companies');
            }
            else {
                errorToast('Возникли ошибки при создании компании');
            }
        }
    }

    updateContacts(contacts) {
        this.setState({contacts});
    }

    updateAddresses(addresses) {
        this.setState({addresses});
    }

    updateProducts(products) {
        this.setState({products});
    }

    createFormDto() {
        return {
            typeId: this.state.typeId,
            name: this.state.name,
            contractorId: this.state.contractorId,
            contacts: this.state.contacts,
            isProviderOfUsed: this.state.isProviderOfUsed,
            isProviderOfNew: this.state.isProviderOfNew,
            hasDryingRoom: this.state.hasDryingRoom,
            completedSupplyCount: this.state.completedSupplyCount,
            failedSupplyCount: this.state.failedSupplyCount,
            repliedSupplyCount: this.state.repliedSupplyCount,
            serviceLevelTypeId: this.state.serviceLevelTypeId,
            isAudited: this.state.isAudited,
            addresses: this.state.addresses,
            isContractSigned: this.state.isContractSigned,
            contractDocuments: [],
            requisiteDocuments: [],
            inn: this.state.inn,
            isTermsAccepted: this.state.isTermsAccepted,
            paymentTypeId: this.state.paymentTypeId,
            hasPaymentDelay: this.state.hasPaymentDelay,
            paymentDelayDays: this.state.paymentDelayDays,
            hasDelivery: this.state.hasDelivery,
            deliveryPrice: this.state.deliveryPrice,
            products: this.state.products,
            comment: this.state.comment,
            requirementDocuments: []
        };
    }
}

export default withRouter(CompanyForm);


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Companies/CompanyForm.js